<app-navigation></app-navigation>

<main id="main-content">
  <router-outlet #outlet="outlet"></router-outlet>
</main>

<div class="cursor" #cursor></div>
